/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
export enum SERVICE_TYPE {
  RAG_CACHE = "RAG_CACHE",
  RAG_PIPELINES = "RAG_PIPELINES",
}

export enum SERVICE_TYPE_SIMPLIFIED {
  CACHE = "cache",
  ANALYTICS = "analytics",
  PIPELINES = "pipelines",
}

export interface IApiKey {
  key: string,
  expiration_date: string | null,
  description: string,
  created_at: string
}

export type CacheType = 'RAGC' | 'TC'

export interface IServiceTypeSettings {
  type: string;
  label: string;
  value: string;
  required: boolean;
  read_only: boolean;
  choices: [] | null;
  cache_type: CacheType;
}

export interface IServiceCustomActions {
  label: string;
  action: string;
  display: boolean;
  params: [];
}

export interface IServiceType {
  key: string;
  title: string;
  is_active: boolean;
  description: string;
  settings: IServiceTypeSettings[];
  custom_actions: IServiceCustomActions[];
}

export interface ISettings {
  type: string;
  label: string;
  value: string;
  required: boolean;
  read_only: boolean;
  choices: Record<string, any>[] | null;
}

interface ICustomService {
  settings: IServiceTypeSettings[];
  api_keys: IApiKey[];
}

export type SettingsFormStructuredData = Record<string, ICustomService>;
